"use strict";
var Observable_1 = require('../../Observable');
var share_1 = require('../../operator/share');
Observable_1.Observable.prototype.share = share_1.share;
//# sourceMappingURL=share.js.map


//////////////////
// WEBPACK FOOTER
// /home/artur/workspace/vscode/warpriders/~/rxjs/add/operator/share.js
// module id = ../../../../rxjs/add/operator/share.js
// module chunks = 3